// extracted by mini-css-extract-plugin
export default {"Notification":"Notification_Notification__1znWd","Notification_entered":"Notification_Notification_entered__3o9W-","Notification__close":"Notification_Notification__close__Xw6Ro"};